export const timeoutErrorMessage =
  'Something went wrong. Please try again later.';
export const exportDelayErrorMessage =
  "Your records are being exported. This may take some time. An email will be sent once it's ready.";
